export default __webpack_public_path__ + "static/media/beeswax-logo.3ad4652f.svg";